import { BoardParticipant, Partner, PartnerRepresentant } from 'types';

type Representative = Partner | PartnerRepresentant | undefined;

export const getRepresentativeFromParticipant = (
  participant: BoardParticipant,
  partners: Partner[],
  partnerRepresentants: PartnerRepresentant[]
): Representative => {
  if (!participant.representative) return undefined;

  const representativesList = participant?.hasPartnerRepresentant
    ? partnerRepresentants
    : partners;

  return representativesList?.find(
    (p: any) => p['_id'] === participant?.representative
  );
};
